import { render, staticRenderFns } from "./schoolUseProDetails.vue?vue&type=template&id=1cf71e22&scoped=true"
import script from "./schoolUseProDetails.vue?vue&type=script&lang=js"
export * from "./schoolUseProDetails.vue?vue&type=script&lang=js"
import style0 from "./schoolUseProDetails.vue?vue&type=style&index=0&id=1cf71e22&prod&lang=scss&scoped=true"
import style1 from "./schoolUseProDetails.vue?vue&type=style&index=1&id=1cf71e22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf71e22",
  null
  
)

export default component.exports